// Monochrome
export const white = '#ffffff';
export const alabaster = '#f9f9f9';
export const gallery = '#eeeeee';
export const alto = '#dadada';
export const silver = '#cccccc';
export const silverChalice = '#aaaaaa';
export const dustyGray = '#999999';
export const gray = '#808080';
export const friarGray = '#7b7b7a';
export const doveGray = '#737373';
export const paleSky = '#6c757d';
export const scorpion = '#585858';
export const emperor = '#505050';
export const mineShaft = '#333333';
export const mineShaftDark = '#212121';
export const black = '#000000';

// White
export const quarterSpanishWhite = '#faf4eb';
export const bridalHeath = '#fff9ee';
export const mystic = '#e1e9ee';
export const wildSand = '#f5f5f5';
export const pearlLusta = '#fcf8e3';
export const champagne = '#faf2cc';
export const bizarre = '#f2dede';
export const oysterPink = '#ebcccc';
export const peppermint = '#dff0d8';
export const zanah = '#d0e9c6';
export const linkWater = '#d9edf7';
export const mintTulip = '#c4e3f3';

// Blue
export const pictonBlue = '#419ee0';
export const astral = '#337ab7';
export const mariner = '#1f7bbd';
export const teal = '#196399';
export const matisse = '#145f96';
export const midnightblue = '#053e94';
export const oxfordBlue = '#3c4858';

// Turquoise
export const scooter = '#26c6da';
export const brightTurquoise = '#00d3ee';
export const pacificBlue = '#00acc1';

// Green
export const sushi = '#80b636';
export const fern = '#66bb6a';
export const apple = '#43a047';
export const fruitSalad = '#4caf50';
export const mediumseagreen = '#299b86';

// Yellow
export const cherokee = '#fbdd9f';
export const birdFlower = '#dacd18';
export const casablanca = '#f8c051';
export const saffronMango = '#f8c052';
export const gamboge = '#e49d0a';

// Orange
export const buttercup = '#f7b31b';
export const sunshade = '#ffa726';
export const orangePeel = '#ff9800';
export const pizazz = '#fb8c00';
export const ecstasy = '#f7761b';
export const blazeOrange = '#ff6a00';
export const tuscany = '#ce5c32';

// Red
export const burntSienna = '#ef5350';
export const pomegranate = '#f44336';
export const cinnabar = '#e53935';
export const red = '#ff0000';
export const radicalRed = '#ff234c';
export const alizarinCrimson = '#e52d27';

// Pink
export const seaPink = '#ec8f8b';
export const frenchRose = '#ea4c89';
export const amaranth = '#e91e63';

// Purple
export const amethyst = '#ab47bc';
export const purpleHeart = '#af2cc5';
export const seance = '#9c27b0';

// Social Network colors
export const twitterBrandColor = '#55acee';
export const denim = '#118CC0';
export const linkedinBrandColor = '#3978B9';
export const instagramBrandColor = '#125688';
export const facebookBrandColor = '#3b5998';
export const behanceBrandColor = '#1769ff';
export const royalblue = '#4632E2';
export const googleBrandColor = '#dd4b39';
export const pinterestBrandColor = '#cc2127';
export const youtubeBrandColor = '#e52d27';
export const tumblrBrandColor = '#35465c';
export const githubBrandColor = '#333333';
export const dribbbleBrandColor = '#ea4c89';
export const redditBrandColor = '#ff4500';
